export const environment = {
    autoSignIn: true,
    popupForLogin: false,
    cacheLocation: "localStorage",
    instance: "https://login.microsoftonline.com/",
    tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
    clientId: "3107e9e4-91a0-48cc-8a9b-7b59dde2e8e7",
    redirectUri: "https://fdm-dev.tengizchevroil.com",
    oidcScopes: ["openid", "profile", "User.Read", "offline_access"],
    graphScopes: ["User.Read", "User.Read.All"],
    apiUrl: "https://fdm-dev-be.tengizchevroil.com",
    scopeUrl: "https://firmdm-test.tengizchevroil.com/user_impersonation",
    powerBiReportUrl: "https://app.powerbi.com/groups/me/rdlreports/d8dfe5b1-7f69-4711-b10d-6da0d5378894?ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26&experience=power-bi"
}